import React from 'react';

import { gql } from '@apollo/client';

import {
  ActivityLogTaskAutoCancelFailed_ActivityLogFragment,
  TaskAutoCancelFailureReason,
} from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

import ActivityLogBase from '../../Helpers/ActivityLogBase';

interface Fragments {
  activityLog: ActivityLogTaskAutoCancelFailed_ActivityLogFragment;
}

const getFailureReasonText = (reason: TaskAutoCancelFailureReason): string => {
  switch (reason) {
    case TaskAutoCancelFailureReason.CalendarPermissionDenied:
      return 'calendar permission was denied';
    case TaskAutoCancelFailureReason.EmployeeDeprovisioned:
      return 'the schedule creator was deprovisioned';
    case TaskAutoCancelFailureReason.CalendarNotFound:
      return 'the calendar was not found';
    case TaskAutoCancelFailureReason.IntegrationDisconnected:
      return 'the calendar integration was disconnected';
    default:
      return 'an unknown error occurred';
  }
};

const ActivityLogTaskAutoCancelFailed: FCWithFragments<Fragments> = ({ activityLog }) => {
  const { details } = activityLog;

  // eslint-disable-next-line no-underscore-dangle
  if (!details || details.__typename !== 'ActivityLogTaskAutoCancelFailedDetails') {
    throw new Error('ActivityLogTaskAutoCancelFailed: details is not ActivityLogTaskAutoCancelFailedDetails');
  }

  const { failureReason } = details;
  const reasonText = getFailureReasonText(failureReason);

  return (
    <ActivityLogBase
      activityLog={activityLog}
      actionLabelKey="hiring-dashboard-candidates:candidates.activityLog.autoCancelFailed"
      actionLabelValues={{ reason: reasonText }}
    />
  );
};

ActivityLogTaskAutoCancelFailed.fragments = {
  activityLog: gql`
    ${ActivityLogBase.fragments.activityLog}
    fragment ActivityLogTaskAutoCancelFailed_activityLog on ActivityLog {
      id
      details {
        ... on ActivityLogTaskAutoCancelFailedDetails {
          __typename
          failureReason
          failureMessage
        }
      }
      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogTaskAutoCancelFailed;
